import React from "react";
import PageWrapper from "./Rd.style";
import { connect } from "react-redux";
import RdViewDetails from "../../components/rd/RdViewDetails";
import PageTitle from "components/common/PageTitle";

const StaticPageView = props => {
  return (
    <PageWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.provider"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.provider",
              url: "/rd"
            },
            {
              name: "action.view"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/rd")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>
      <div className="user-tbl">
        <RdViewDetails {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.permissionReducer,
    ...state.themeChanger,
    auth: state.auth
  };
};

export default connect(mapStateToProps, null)(StaticPageView);
